module.exports = __webpack_public_path__ + "img/2.b26da043.jpg";